/* eslint-disable jira/naming/disallow-filenames */

import React from 'react';
import type ForgeProjectSettingsPageType from '@jira/spa-apps__forge-project-settings/src/ForgeProjectSettingsPageShellWithAnalytics.tsx';
import { projectContextResourceWithCache } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { forgeProjectSettingsModuleResource } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import type { ProjectSettingsPage } from '@jira/forge__forge-ui-types/src/common/types/extension.tsx';
import type { ProjectContext } from '@jira/router-resources__project-context/src/ProjectContext.types.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';
import type { RouteResource } from '@atlassian/react-resource-router';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyForgeProjectSettingsPage: LazyComponent<React.ComponentType<Record<any, any>>> =
	lazyForPaint<typeof ForgeProjectSettingsPageType>(
		() =>
			import(
				/* webpackChunkName: "async-forge-spa-project-settings", jiraSpaEntry: "async-forge-spa-project-settings" */ '@jira/spa-apps__forge-project-settings/src/ForgeProjectSettingsPageShellWithAnalytics.tsx'
			),
	);

export const forgeProjectSettingsPageResources = (): readonly [
	RouteResource<ProjectContext | null>,
	RouteResource<ProjectSettingsPage[]>,
] => [projectContextResourceWithCache, forgeProjectSettingsModuleResource] as const;

export const ForgeProjectSettingsPage = (): React.JSX.Element => (
	<LazyPage
		Page={LazyForgeProjectSettingsPage}
		pageId="forge-spa-project-settings"
		shouldShowSpinner
	/>
);

export default ForgeProjectSettingsPage;
